function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/* global Highcharts, _ */

(function () {
  'use strict';

  var id = "program";
  angular.module('wsLrs.controllers').factory(id + ".Utils", ['$q', '$routeParams', 'Api', 'CardQueryResource', 'Utils', 'wsColors', 'User', 'ViewDashboardsAs', '$http', '$location', function ($q, $routeParams, Api, CardQueryResource, Utils, wsColors, User, ViewDashboardsAs, $http, $location) {
    var cachedPromises = {};
    return {
      filterHiddenSortControls: function filterHiddenSortControls($scope) {
        var controller = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'program';
        var durationHideables = ['duration', 'averageTimeToComplete', 'timeSpan', 'averageTimeSpan'];
        var hideOptions = 'hideOptions' in $scope.config ? $scope.config.hideOptions : {};
        var durationsHidden = hideOptions.program && hideOptions.program.duration;
        var filteredControls = $scope.sortControls.reduce(function (filtered, control) {
          var camelTitle = Utils.toCamelCase(control.title);
          var isHideableDuration = durationsHidden && durationHideables.includes(camelTitle);

          // if no `hideOptions` are specified, we will get an exception trying to read objects
          // or attributes that may be defined there, but the exception is really not relevant, and
          // there's no real reason to report it since it simply indicates that the control should NOT
          // be hidden by this function
          var hidden = false;
          try {
            if (isHideableDuration) {
              hidden = true;
            } else {
              hidden = camelTitle in hideOptions[controller] && hideOptions[controller][camelTitle] === true;
            }
          } catch (e) {
            // the real 'exception' here is that 'duration' values are all over program reports and
            // the pre-existing `hideDuration` option literally hides each of them.  so, we add a check
            // to see whether the specific sort control is one of those values before leaving it unhidden
            if (durationHideables.includes(camelTitle)) {
              hidden = hidden || isHideableDuration;
            }
          }
          if (!hidden) {
            filtered.push(control);
          }
          return filtered;
        }, []);

        // if all table columns/headers are hidden, hide the section from the
        // program level and remove the individual options from the section
        if (filteredControls.length <= 0) {
          $scope.config.hideOptions.program = Object.assign({}, $scope.config.hideOptions.program);
          $scope.config.hideOptions.program[controller] = true;
          delete $scope.config.hideOptions[controller];
        }
        return filteredControls;
      },
      fetchProgramData: function fetchProgramData(cardId, $scope, params) {
        var dataUrl;

        // We'll hit a different resource depending on the the existence of particular ids which
        // would indicate that this is being called in the context of a specific type of detail page
        if ($scope.personId) {
          dataUrl = "/program/person/" + $scope.personId;
        } else if ($scope.assessmentIndex) {
          dataUrl = "/program/assessment/" + $scope.assessmentIndex;
        } else if ($scope.competencyId) {
          dataUrl = "/program/competency/" + $scope.competencyId;
        } else if ($scope.groupId) {
          dataUrl = "/program/group/" + $scope.groupId;
        } else if ($scope.workflowId) {
          dataUrl = "/program/workflow/" + $scope.workflowId;
        } else if ($scope.learningPathId) {
          dataUrl = "/program/learningpath/" + $scope.learningPathId;
        } else if ($scope.dataOriginIndex) {
          dataUrl = "/program/dataorigin/" + $scope.dataOriginIndex;
        } else {
          dataUrl = "/program";
        }
        if (params === null || params === undefined) {
          params = {};
        }

        // Allowing 5 levels of milestones for now...
        if ($routeParams.milestone1) {
          params.milestone = $routeParams.milestone1;
          $scope.currentMilestone = $routeParams.milestone1;
        }
        if ($routeParams.milestone2) {
          params.milestone += "," + $routeParams.milestone2;
          $scope.currentMilestone = $routeParams.milestone2;
        }
        if ($routeParams.milestone3) {
          params.milestone += "," + $routeParams.milestone3;
          $scope.currentMilestone = $routeParams.milestone3;
        }
        if ($routeParams.milestone4) {
          params.milestone += "," + $routeParams.milestone4;
          $scope.currentMilestone = $routeParams.milestone4;
        }
        if ($routeParams.milestone5) {
          params.milestone += "," + $routeParams.milestone5;
          $scope.currentMilestone = $routeParams.milestone5;
        }
        var fetchCfg = {
          path: dataUrl,
          cardId: cardId,
          params: params,
          progressChannel: 'programProgress-' + cardId
        };
        if ($location.search().filter) {
          fetchCfg.filter = $location.search().filter;
        }

        // Attach the uid for caching key purposes
        var currentUser = User.get();
        if (currentUser && currentUser.user) {
          fetchCfg.uid = currentUser.user.id;
        }
        if (ViewDashboardsAs.isActive && ViewDashboardsAs.selectedUser) {
          fetchCfg.uid = ViewDashboardsAs.selectedUser.id;
        }

        // If this is a preview, we'll post this and get a temp cache Id because large configs
        // are too large for the query string.
        var cardQueryCacheKey;

        //remove all the canceled promises
        cachedPromises = _.omit(cachedPromises, function (p) {
          return p.$$state.status === -1;
        });
        if ($scope.cardToPreview) {
          // With this new POST/GET method of sending configs we need to make a version
          // of the fetchConfig that actually uses the config string for caching purposes.
          var cacheKeyData = angular.copy(fetchCfg);
          cacheKeyData.cardToPreview = $scope.cardToPreview.configuration;
          cardQueryCacheKey = Utils.appendParams(Api.url(dataUrl), cacheKeyData);
          if (!(cardQueryCacheKey in cachedPromises)) {
            return $http.post(Api.url(dataUrl + "/preview-config"), $scope.cardToPreview.configuration).then(function success(response) {
              var previewCardConfigCacheId = response.data.key;
              fetchCfg.cardToPreview = {
                "configuration": previewCardConfigCacheId
              };
              cachedPromises[cardQueryCacheKey] = CardQueryResource.getWithProgress(fetchCfg);
              return cachedPromises[cardQueryCacheKey].then(function (data) {
                return data;
              });
            });
          } else {
            return cachedPromises[cardQueryCacheKey].then(function (data) {
              return data;
            });
          }
        } else {
          cardQueryCacheKey = Utils.appendParams(Api.url(dataUrl), fetchCfg);
          if (!(cardQueryCacheKey in cachedPromises)) {
            cachedPromises[cardQueryCacheKey] = CardQueryResource.getWithProgress(fetchCfg);
          }
          return cachedPromises[cardQueryCacheKey].then(function (data) {
            return data;
          });
        }
      },
      // This will fetch the whole set of Program data.  getListerData is a function that will extract
      // a particular array for use by one of the listers
      fetchData: function fetchData(params, $scope, getListerData) {
        if ($scope.fetchInProgress) {
          return $scope.dataFetched;
        } else if ($scope.cachedListerItems) {
          var sortedList = this.searchAndSort($scope.cachedListerItems, params);
          var deferred = $q.defer();
          deferred.resolve(sortedList);
          return deferred.promise;
        } else {
          $scope.fetchInProgress = true;
          var self = this;
          return this.fetchProgramData($routeParams.cardId, $scope).then(function doit(response) {
            return getListerData(response.results[0].result);

            // return a promise that returns the new promise and the original response
          }).then(function success(response) {
            $scope.cachedListerItems = response;
            $scope.fetchInProgress = false;
            $scope.hasData = $scope.cachedListerItems && $scope.cachedListerItems.length > 0;
            if ($scope.cachedListerItems && $scope.cachedListerItems.then) {
              $scope.cachedListerItems = $scope.cachedListerItems.then(function (data) {
                $scope.cachedListerItems = data;
                return self.searchAndSort($scope.cachedListerItems, params);
              });
            } else {
              // We are sorting here because the default lister behavior of sorting at the
              // resource won't work for us since all of our data comes form a single resource
              // This will default to a 'name' sort
              return self.searchAndSort($scope.cachedListerItems, params);
            }
          });
        }
      },
      // Used in conjunction with the lister and search functionality
      searchAndSort: function searchAndSort(results, params) {
        /*jshint camelcase: false */
        // Filter if we have a name search
        if (params.in_name) {
          results = _.filter(results, function (x) {
            var name = x.name.toLowerCase();
            var searchString = params.in_name.toLowerCase();
            return name.indexOf(searchString) > -1;
          });
        }
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0,
          orderBy = params.order_by || "name";
        var reverse = false;
        if (orderBy.lastIndexOf("-", 0) === 0) {
          orderBy = orderBy.substring(1, orderBy.length);
          reverse = true;
        }
        var orderingMethod = null;
        if (orderBy === "name") {
          orderingMethod = function orderingMethod(item) {
            return item.name ? item.name.toLowerCase() : "";
          };
        } else if (orderBy !== "none") {
          orderingMethod = function orderingMethod(item) {
            return item[orderBy];
          };
        }
        if (orderingMethod !== "none") {
          results = _.sortBy(results, orderingMethod);
          if (reverse) {
            results.reverse();
          }
        }

        // numResults is the TOTAL (after the search filter), before slicing out a page
        var numResults = _.size(results);
        results = results.slice(offset, limit + offset);
        return {
          "results": results,
          "count": numResults
        };
      },
      clearCachedPromises: function clearCachedPromises() {
        cachedPromises = {};
      },
      /*jshint camelcase: false */
      fetchSearchSuggestions: function fetchSearchSuggestions(params, $scope) {
        var deferred = $q.defer();
        var matches = _.filter($scope.cachedListerItems, function (x) {
          var name = x.name.toLowerCase();
          var searchString = params.in_name.toLowerCase();
          return name.indexOf(searchString) > -1;
        });
        deferred.resolve({
          "results": matches
        });
        return deferred.promise;
      },
      setupActivityChart: function setupActivityChart(dailyActivity, $scope) {
        var maxDailyActivity = _.reduce(dailyActivity, function (memo, arr) {
          if (arr[1] > memo) {
            return arr[1];
          } else {
            return memo;
          }
        }, 0);
        $scope.totalActivities = _.reduce(dailyActivity, function (memo, arr) {
          return memo + arr[1];
        }, 0);
        var lastDayWithData;
        _.each(dailyActivity, function (pair) {
          // pair is <date>|<count of activities>, date is originally in millis so is parsed here
          pair[0] = Date.parse(pair[0]);
          if (pair[1] > 0) {
            lastDayWithData = pair[0];
          }
        });

        // Only show chart data up to the last date that actually has data
        var dailyActivitySeries = _.filter(dailyActivity, function (pair) {
          return pair[0] <= lastDayWithData;
        });
        $scope.activityChart = {
          credits: {
            enabled: false
          },
          chart: {
            type: 'areaspline',
            margin: [10, 0, 0, 0],
            height: 80
          },
          title: {
            text: null
          },
          xAxis: {
            labels: {
              enabled: false
            },
            lineWidth: 0,
            gridLineWidth: 0
          },
          yAxis: {
            title: {
              text: null
            },
            labels: {
              enabled: false
            },
            lineWidth: 0,
            gridLineWidth: 0,
            max: maxDailyActivity,
            // Series max
            min: 0
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              lineWidth: 1,
              fillOpacity: 0.5,
              marker: {
                enabled: true,
                symbol: 'circle',
                radius: 2,
                fillColor: wsColors.wsGray
              }
            }
          },
          series: [{
            name: 'Activity',
            data: dailyActivitySeries,
            color: wsColors.wsBlue
          }],
          tooltip: {
            formatter: function formatter() {
              return '<div class="watershed-tooltip" ><table>' + '<tr><td>' + (this.y + (this.y === 1 ? ' activity ' : ' activities ') + 'on ' + Highcharts.dateFormat('%b  %e, %Y', new Date(this.x)) + '.') + '</td></tr>' + '</table></div>';
            }
          }
        };
      }
    };
  }]).config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.
    //route format MUST be: card.template.name + "/" + card.id
    when('/program/:cardId', {
      templateUrl: 'modules/app/program/program-detail.html',
      controller: id + '.Detail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/top', {
      templateUrl: 'modules/app/program/program-card.html',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/milestone/:milestone1?/:milestone2?/:milestone3?/:milestone4?/:milestone5?', {
      templateUrl: 'modules/app/program/program-detail.html',
      controller: id + '.Detail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/person/:personId', {
      templateUrl: 'modules/app/program/person.html',
      controller: id + '.Person',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/assessment/:assessmentIndex', {
      templateUrl: 'modules/app/program/assessment.html',
      controller: id + '.Assessment',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/group/:groupId', {
      templateUrl: 'modules/app/program/program-detail.html',
      controller: id + '.Detail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/group/:groupId/milestone/:milestone1?/:milestone2?/:milestone3?/:milestone4?/:milestone5?', {
      templateUrl: 'modules/app/program/program-detail.html',
      controller: id + '.Detail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/learningpath/:learningPathId', {
      templateUrl: 'modules/app/program/learning-path.html',
      controller: id + '.LearningPathDetail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/dataorigin/:dataOriginIndex', {
      templateUrl: 'modules/app/program/data-origin.html',
      controller: id + '.DataOriginDetail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/competency/:competencyId', {
      templateUrl: 'modules/app/program/competency.html',
      controller: id + '.Competency',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/program/:cardId/workflow/:workflowId', {
      templateUrl: 'modules/app/program/workflow.html',
      controller: id + '.WorkflowDetail',
      resolve: {
        loadCards: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "program": "program"
    });
  }]).controller(id + ".Card", ["$scope", "CardRegistry", id + ".Utils", "wsEventNames", "$routeParams", function ($scope, CardRegistry, Utils, wsEvents, $routeParams) {
    // todo: remove this comment--it's just here to investigate failed deployments (wslrs-12244)

    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.defaultSummary = "Details about this training and development program";
    if (!$scope.config || !$scope.config.program || !$scope.config.program.learningPaths || $scope.config.program.learningPaths.length === 0) {
      $scope.noDataMsg = "Please configure at least one program step";
      $scope.hasData = false;
      return;
    }

    // For card-creation time
    if ($scope.cardId === 'preview') {
      $scope.cardToPreview = $scope.card;
    }
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($scope.cardId, $scope).then(function success(response) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, response);
      }
      var data = response.results[0].result;
      $scope.fetchInProgress = false;
      $scope.program = data.program;
      $scope.hasData = true;
    }, function error(e) {
      $scope.hasData = false;
      if (e.message && e.message.indexOf && e.message.indexOf("Invalid configuration" > -1)) {
        $scope.noDataMsg = "Invalid configuration";
      } else if (e === 'canceled') {// jshint ignore:line
        // Do nothing because promise was canceled
      } else {
        throw e;
      }
    });
  }]).controller(id + '.Detail', ['$scope', 'CardUtils', '$routeParams', '$timeout', 'CardQueryResource', 'CardRegistry', id + ".Utils", "activity.Utils", id + '.PageText', function ($scope, CardUtils, $routeParams, $timeout, CardQueryResource, CardRegistry, Utils, ActivityUtils, PageText) {
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.config = $scope.card.configuration;
    if (!$scope.config || !$scope.config.program || !$scope.config.program.learningPaths || $scope.config.program.learningPaths.length === 0) {
      $scope.noDataMsg = "Please configure at least one program step";
      $scope.hasData = false;
      return;
    }

    // For card-creation time
    if ($routeParams.cardId === 'preview') {
      $scope.cardToPreview = $scope.card;
      $scope.isPreview = true;
    }

    // This controller is used for the group detail view as well.
    // The existence of this variable will cause fetchProgramData to go after a group-specific resource
    $scope.groupId = $routeParams.groupId;
    $scope.shareSuffix = "";
    if ($routeParams.shareKey) {
      $scope.shareSuffix = "?shareKey=" + $routeParams.shareKey;
    }

    // We have to augment the base filter for statements only related to a particular group -- this
    // is the same thing we do server-side for the interactions resources for Program drilldown pages.
    var filter = _.extend({}, $scope.config.filter);
    if ($scope.groupId) {
      filter.groupIds = [$scope.groupId];
    }
    CardUtils.setNavElements($scope, $routeParams.cardId, $routeParams.cardId);
    var routeHasQueryParams = function routeHasQueryParams(r) {
      return r && typeof r.indexOf === 'function' && r.indexOf('?') > -1;
    };
    var addRouteSuffix = function addRouteSuffix(r, s) {
      if (routeHasQueryParams(r)) {
        return r.replace('?', '/' + s + '?');
      }
      return r + '/' + s;
    };
    var dropRouteParams = function dropRouteParams(r) {
      return routeHasQueryParams(r) ? r.slice(0, r.indexOf('?')) : r;
    };
    var getRouteSuffix = function getRouteSuffix(r) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$size = _ref.size,
        size = _ref$size === void 0 ? 1 : _ref$size,
        _ref$separator = _ref.separator,
        separator = _ref$separator === void 0 ? '/' : _ref$separator,
        from = _ref.from;
      var route = dropRouteParams(r).split('/');
      var i = route.length - size;
      if (from !== undefined) {
        if (typeof from === 'number') {
          i = from;
        }
        if (typeof from === 'string' && route.includes(from)) {
          i = route.indexOf(from) + 1;
        }
      }
      return route.slice(i).join(separator);
    };
    var getMilestoneSuffix = function getMilestoneSuffix() {
      if (!$scope.isProgramRoot) {
        return getRouteSuffix($scope.milestoneBaseUrl, {
          from: 'milestone',
          separator: ','
        });
      }
    };
    $scope.milestoneBaseUrl = window.location.href;
    $scope.isProgramRoot = $scope.milestoneBaseUrl.indexOf('milestone') < 0;
    if ($scope.isProgramRoot) {
      $scope.milestoneBaseUrl = addRouteSuffix($scope.milestoneBaseUrl, 'milestone');
    }
    $scope.getMilestoneUrl = function (id) {
      return addRouteSuffix($scope.milestoneBaseUrl, encodeURIComponent(id));
    };
    var milestoneSuffix = getMilestoneSuffix();
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      hide: $scope.cardId === 'preview',
      href: CardQueryResource.getDownloadUrl('program/csv', $scope.card.id, $scope.config) + "&table=all" + (angular.isDefined($routeParams.groupId) ? "&groupId=" + $routeParams.groupId : "" + milestoneSuffix ? "&milestone=" + milestoneSuffix : "")
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: ActivityUtils.prepareCsvExport(filter).csvDownloadUrl
    }];

    // ProgramCardConfiguration has a server-side override of getOptimizedFilter. We have to pass
    // in the card id to get an instance of this subType so it calls the correct optimizedFilter method.
    if (!$scope.isPreview) {
      $scope.subDetails[1].callback = $scope.subDetails[1].callback + "&cardId=" + $scope.card.id;
    }
    $scope.pagenote = {
      clearCacheAction: "cards/" + $scope.card.id + "/cache",
      windowReload: true
    };
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($routeParams.cardId, $scope).then(function success(response) {
      var data = response.results[0].result;
      $scope.fetchInProgress = false;
      $scope.program = data.program;
      $scope.milestones = data.milestones;
      $scope.groupName = data.groupName;

      // List all groups together
      if (!$scope.config.listGroupsByType) {
        $scope.groupTableNames = ["groups"];

        // List groups by type
      } else {
        $scope.groupTableNames = Object.keys(data).filter(function (k) {
          return k.indexOf('groupsOfType__') >= 0;
        });
      }
      $scope.milestonesTotalPercentComplete = _.reduce($scope.milestones, function (memo, milestone) {
        return memo + milestone.percentAtStep;
      }, 0);
      $scope.hasData = true;
      var pageText = PageText.bind({
        cardConfig: $scope.config
      }).lift("peopleInProgram", function () {
        return this.render('program.detail.peopleInProgram', {
          detailType: "program"
        });
      }).lift("peopleInMilestone", function () {
        return this.render('program.milestoneDetail.peopleInMilestone', {
          detailType: "milestone"
        });
      }).lift("totalPeople", function () {
        return this.render('program.detail.totalPeople', {
          totalPeople: $scope.program.totalPeople
        });
      }).lift("peopleCurrentlyEnrolled", function () {
        return this.render('program.detail.peopleCurrentlyEnrolled');
      }).lift("completions", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var path = "program.".concat(isProgramRoot ? 'detail.programCompletions' : 'milestoneDetail.milestoneCompletions');
        var detailType = isProgramRoot ? "Program" : "Milestone";
        return this.render(path, {
          detailType: detailType
        });
      }).lift("peopleComplete", function () {
        return this.render('program.detail.peopleComplete', {
          peopleComplete: $scope.program.peopleComplete
        });
      }).lift("peopleCompletedThisPart", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var path = "program.".concat(isProgramRoot ? 'detail.peopleCompletedThisProgram' : 'milestoneDetail.peopleCompletedThisMilestone');
        return this.render(path);
      }).lift("inProgress", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var path = "program.".concat(isProgramRoot ? 'detail.programInProgress' : 'milestoneDetail.milestoneInProgress');
        var detailType = isProgramRoot ? "Program" : "Milestone";
        return this.render(path, {
          detailType: detailType
        });
      }).lift("peopleInProgress", function () {
        return this.render('program.detail.peopleInProgress', {
          peopleInProgress: $scope.program.peopleInProgress
        });
      }).lift("peopleInProgressThisPart", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var path = "program.".concat(isProgramRoot ? 'detail.peopleInProgressThisProgram' : 'milestoneDetail.peopleInProgressThisMilestone');
        return this.render(path);
      }).lift("notStarted", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var path = "program.".concat(isProgramRoot ? 'detail.programNotStarted' : 'milestoneDetail.milestoneNotStarted');
        var detailType = isProgramRoot ? "Program" : "Milestone";
        return this.render(path, {
          detailType: detailType
        });
      }).lift("peopleNotStarted", function () {
        return this.render('program.detail.peopleNotStarted', {
          peopleNotStarted: $scope.program.peopleNotStarted
        });
      }).lift("peopleNotStartedThisPart", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var path = "program.".concat(isProgramRoot ? 'detail.peopleNotStartedThisProgram' : 'milestoneDetail.peopleNotStartedThisMilestone');
        return this.render(path);
      }).lift("averageTimeToComplete", function () {
        return this.render('program.detail.averageTimeToComplete', {
          detailType: $scope.isProgramRoot ? "program" : "milestone"
        });
      }).lift("averageElaspsedToCompleteSeconds", function () {
        return this.render('program.detail.averageElapsedToCompleteSeconds', {
          averageElapsedToCompleteSeconds: $scope.program.averageElaspsedToCompleteSeconds
        });
      }).lift("timeToCompleteAllRequirements", function () {
        return this.render('program.detail.timeToCompleteAllRequirements');
      }).lift("programMilestones", function () {
        return this.render('program.detail.programMilestones');
      }).lift("milestoneActivities", function (milestoneName) {
        return this.render('program.milestoneDetail.milestoneActivities', {
          milestoneName: milestoneName
        });
      }).lift("whatPercentageOfEnrolled", function () {
        var isProgramRoot = $scope.isProgramRoot;
        var isOrdered = $scope.program.ordered;
        var path = "program.".concat(isProgramRoot ? 'detail' : 'milestoneDetail');
        if (isOrdered) {
          return this.render("".concat(path, ".whatPercentageOfEnrolled_ordered"));
        }
        return this.render("".concat(path, ".whatPercentageOfEnrolled"));
      }).lift("groupSectionHeader", function (count) {
        var singular = "Group";
        return this.render('program.detail.groupSectionHeader', {
          resultCount: count,
          resultType: count === 1 ? singular : singular + 's'
        });
      }).lift("renderHeadline", function (groupName, avgProgress, precision, card, program) {
        var programName = program.name === '' ? card.title : program.name;
        if (avgProgress === 0) {
          return this.render('program.groupDetail.noPeopleHaveStartedProgram', {
            groupName: groupName,
            programName: programName
          });
        }
        if (avgProgress === 1.0) {
          return this.render('program.groupDetail.allPeopleHaveStartedProgram', {
            groupName: groupName,
            programName: programName
          });
        }
        var p = Math.pow(10, precision);
        var avgProgressPct = Math.round(avgProgress * 100 * p) / p;
        return this.render('program.groupDetail.peopleCompletedPercentage', {
          groupName: groupName,
          avgProgressPct: avgProgressPct,
          programName: programName
        });
      }).lift("groupDetailHeadline", function (groupId, groupName, avgProgress, card, program) {
        if (groupId) {
          return this.renderHeadline(groupName, avgProgress, 1, card, program);
        }
      });
      $scope.pageText = pageText;
      if ($scope.groupId) {
        // Base url for fetching interactions -- this is unique because we need the
        // card's filter plus the group Id we feed it
        $scope.baseUrl = "program/group/" + $scope.groupId + "/interactions";
        CardUtils.setNavElements($scope, data.groupName);
        Utils.setupActivityChart(data.dailyActivity, $scope);
      } else {
        $scope.baseUrl = "program/group/-1/interactions";
        Utils.setupActivityChart(data.dailyActivity, $scope);
      }
      if ($scope.currentMilestone && $scope.currentMilestone.length > 0) {
        $scope.baseUrl += "?milestone=" + $scope.currentMilestone;
      }

      // Conditional code when using this controller for a specific group
      if ($scope.groupId) {
        $scope.avgProgress = data.program.averageProgress;
      } else {
        CardUtils.setNavElements($scope, $routeParams.cardId, $routeParams.cardId);
      }

      // Setup pagenote with our response info
      var reportMetadata = _.extend({}, response);
      reportMetadata.totalHits = response.processedHits;
      reportMetadata.refreshStartedOn = response.refreshStartedOn;
      reportMetadata.durationMillis = response.durationMillis;
      $timeout(function () {
        $scope.pagenote && $scope.pagenote.setReportMetadata && $scope.pagenote.setReportMetadata(reportMetadata);
      });
    }, function error(e) {
      $scope.hasData = false;
      if (e.message && e.message.indexOf && e.message.indexOf("Invalid configuration" > -1)) {
        $scope.noDataMsg = "Invalid configuration";
      } else {
        throw e;
      }
    });
  }]).controller(id + '.WorkflowLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a workflow";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Name",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Completion rate",
      "options": {
        "Ascending": "completionRate",
        "Descending": "-completionRate"
      }
    }, {
      "title": "Starts",
      "options": {
        "Ascending": "starts",
        "Descending": "-starts"
      }
    }, {
      "title": "Completions",
      "options": {
        "Ascending": "completions",
        "Descending": "-completions"
      }
    }];
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.workflows;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.GroupLister', ['$scope', '$attrs', '$q', id + ".Utils", '$routeParams', '$controller', 'GroupUtils', function ($scope, $attrs, $q, Utils, $routeParams, $controller, GroupUtils) {
    $scope.tableName = "groups";
    $scope.setTableName = function (tableName) {
      $scope.tableName = tableName;
    };
    $scope.getTableNameHeading = function (tableName) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (!tableName || tableName === "groups") {
        return count + " Group" + (count > 1 ? "s" : "");
      }
      var groupLabel = tableName.substring("groupsOfType__".length);
      if (count > 1) {
        var lastChar = groupLabel[groupLabel.length - 1];
        if (lastChar === "y") {
          groupLabel = groupLabel.substring(0, groupLabel.length - 1) + "ies";
        } else {
          groupLabel = groupLabel + "s";
        }
      }
      return count + " " + groupLabel;
    };
    $scope.searchPlaceholder = "Search for a group";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Group",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Average progress",
      "options": {
        "Ascending": "averageProgress",
        "Descending": "-averageProgress"
      }
    }, {
      "title": "People not started",
      "options": {
        "Ascending": "peopleNotStarted",
        "Descending": "-peopleNotStarted"
      }
    }, {
      "title": "People in-progress",
      "options": {
        "Ascending": "peopleInProgress",
        "Descending": "-peopleInProgress"
      }
    }, {
      "title": "People completed",
      "options": {
        "Ascending": "peopleComplete",
        "Descending": "-peopleComplete"
      }
    }, {
      "title": "Average time to complete",
      "options": {
        "Ascending": "averageElaspsedToCompleteSeconds",
        "Descending": "-averageElaspsedToCompleteSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope, 'groups');
    $scope.groupsLoaded = false;
    function getCompletedPeoplePct(item) {
      return 100 * item.percentComplete;
    }
    $scope.getCompletedPeoplePct = getCompletedPeoplePct;
    function fetchGroupResults(params) {
      if (params.ids && params.ids.length === 0) {
        $scope.groupsLoaded = true;
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params.table = $scope.tableName;
      return Utils.fetchProgramData($routeParams.cardId, $scope, params).then(function (results) {
        var result = results.results[0].result;
        $scope.groupsLoaded = true;
        return {
          "results": result.data,
          "count": result.count
        };
      });
    }
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchProgramData($routeParams.cardId, $scope, params).then(function (response) {
        var data = response.results[0].result;
        // Look at data.config because it has translated custom ids into internal ids

        // Legacy way -- show all groups on top details page, searchable list
        if (data.config.flattenGroups && !$scope.groupId) {
          return fetchGroupResults(params);
        }

        // Top level group given, lookup immediate children
        if ($scope.groupId > 0) {
          return GroupUtils.getGroup($scope.groupId).then(function (group) {
            params.ids = group.childGroupIds;
            return fetchGroupResults(params);
          });
        } else {
          // Explicit group list given, use those groups
          var explicitGroupIds = data.config.filter.groupIds;

          // If no explcit groups, check the ANDs (Because of quick filters) and take the first
          // list which should be the original list (before quick filter applied)
          if (!explicitGroupIds && data.config.filter.and) {
            _.each(data.config.filter.and, function (subFilter) {
              if (!explicitGroupIds && subFilter.groupIds) {
                explicitGroupIds = subFilter.groupIds;
              }
            });
          }
          if (explicitGroupIds && explicitGroupIds.length > 0) {
            params.ids = explicitGroupIds;
            return fetchGroupResults(params).then(function (data) {
              if (data.count > 0) {
                return data;

                // Fall through to simply getting the root below if this resulted in no groups
                // showing up... for instance, when the card is configured for USA but the user
                // only has permissions to TN
              } else {
                return GroupUtils.getRootGroups({
                  onlyRootsUnder: params.ids
                }).then(function (response) {
                  params.ids = _.map(response, function (group) {
                    return group.id;
                  });
                  return fetchGroupResults(params);
                });
              }
            });
          } else if (data.config.filter.groupTypeNames && data.config.filter.groupTypeNames.length > 0) {
            // If we just have group types defined, our returned data will just have the roots
            return fetchGroupResults(params);
          } else {
            // Filter down to just root groups for display
            var rootGroupsParams = data.config.filter.groupIds ? {
              onlyRootsUnder: data.config.filter.groupIds
            } : {};
            return GroupUtils.getRootGroups(rootGroupsParams).then(function (response) {
              params.ids = _.map(response, function (group) {
                return group.id;
              });
              return fetchGroupResults(params);
            });
          }
        }
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]).controller(id + '.PeopleLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', 'CardRegistry', id + '.PageText', function ($scope, $q, Utils, $routeParams, $controller, CardRegistry, PageText) {
    $scope.formatDate = function formatDate(dateStr) {
      return new Date(dateStr).toUTCString().replace("GMT", "UTC");
    };
    $scope.searchPlaceholder = "Search for a person";
    $scope.searchBy = "name";
    $scope.pageSize = 10;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    var card = CardRegistry.get($routeParams.cardId);
    var config = card.configuration;
    var pageText = PageText.bind({
      cardConfig: config
    }).lift("lastMilestoneProgressTableHeader", function () {
      return this.render('program.detail.lastMilestoneProgress');
    });
    $scope.pageText = pageText;
    $scope.defaultSortBy = "name";
    $scope.sortControls = [{
      "title": "Person",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Progress",
      "options": {
        "Ascending": "progress",
        "Descending": "-progress"
      }
    }, {
      "title": "Status",
      "options": {
        "Ascending": "progress",
        "Descending": "-progress"
      }
    }, {
      "title": pageText.lastMilestoneProgressTableHeader(),
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }, {
      "title": "Time Span",
      "options": {
        "Ascending": "totalElaspsedToCompleteSeconds",
        "Descending": "-totalElaspsedToCompleteSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope, 'people');
    var hasGroupsOfType = function hasGroupsOfType(config) {
      return typeof config.groupsOfType !== 'undefined';
    };
    var addGroupsOfType = hasGroupsOfType(config);
    var groupTypes = addGroupsOfType ? config.groupsOfType.groupTypes : [];
    // todo: allow sorting on group-type columns
    var groupTypeSortControls = groupTypes.map(function (title) {
      return {
        title: title
      };
    });
    $scope.sortControls = $scope.sortControls.concat(groupTypeSortControls);
    $scope.peopleLoaded = false;
    $scope.fetchData = function fetchData(params) {
      params.table = "people";
      return Utils.fetchProgramData($routeParams.cardId, $scope, params).then(function (results) {
        $scope.peopleLoaded = true;
        var result = results.results[0].result;
        var extendedTableData = result.data.map(function (x) {
          var gs = groupTypes.reduce(function (acc, groupType) {
            var groups = typeof x.groupsOfType[groupType] !== 'undefined' ? x.groupsOfType[groupType] : [];
            // todo: only take the first element for agreegationType = 'First' or 'Last'
            // todo: show 'groups' in a modal for agreegationType = 'Set' or 'List'
            var group = groups.length > 0 ? groups[0] : '--';
            return [].concat(_toConsumableArray(acc), [{
              groupType: groupType,
              group: group
            }]);
          }, []);
          x.groupsOfType = gs;
          return x;
        });
        return {
          "results": extendedTableData,
          "count": result.count
        };
      });
    };
    $scope.fetchSearchSuggestions = function (params) {
      if (!params.in_name || params.in_name.length < 3) {
        return $q.resolve({
          "results": [],
          "count": 0
        });
      }
      params._limit = 10;
      params._offset = 0;
      return $scope.fetchData(params);
    };
  }]).controller(id + '.LearningPathsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a person";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Learning Path",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Average progress",
      "options": {
        "Ascending": "averageProgress",
        "Descending": "-averageProgress"
      }
    }, {
      "title": "People in-progress",
      "options": {
        "Ascending": "peopleInProgress",
        "Descending": "-peopleInProgress"
      }
    }, {
      "title": "People completed",
      "options": {
        "Ascending": "peopleComplete",
        "Descending": "-peopleComplete"
      }
    }, {
      "title": "Average time span",
      "options": {
        "Ascending": "totalElaspsedToCompleteSeconds",
        "Descending": "-totalElaspsedToCompleteSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.learningPaths;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({
      "order_by": "none"
    });
  }]).controller(id + '.AssessmentsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an assessment";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Assessment",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "People completed",
      "options": {
        "Ascending": "completionCount",
        "Descending": "-completionCount"
      }
    }, {
      "title": "Successes",
      "options": {
        "Ascending": "successCount",
        "Descending": "-successCount"
      }
    }, {
      "title": "Average score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "totalDurationSeconds",
        "Descending": "-totalDurationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return _.map(data.assessments, function (item, index) {
          item.id = index;
          return item;
        });
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({
      "order_by": "none"
    });
  }]).controller(id + '.CompetenciesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a competency";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Competency",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Average proficiency",
      "options": {
        "Ascending": "averageProficiency",
        "Descending": "-averageProficiency"
      }
    }, {
      "title": "People with competency",
      "options": {
        "Ascending": "proficientCount",
        "Descending": "-proficientCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "matchCount",
        "Descending": "-matchCount"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "totalDurationSeconds",
        "Descending": "-totalDurationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.competencies;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({
      "order_by": "none"
    });
  }]).controller(id + '.ContributingSystemsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a system";
    $scope.pageSize = 50;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Contributing System",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "People that use the system",
      "options": {
        "Ascending": "uniqueUserCount",
        "Descending": "-uniqueUserCount"
      }
    }, {
      "title": "Activities",
      "options": {
        "Ascending": "uniqueActivityCount",
        "Descending": "-uniqueActivityCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      params.limit = params.limit || $scope.pageSize;
      return Utils.fetchData(params, $scope, function getListerData(data) {
        if ($scope.config.program.dataOrigins === null || $scope.config.program.dataOrigins.length === 0) {
          return [];
        }
        return data.dataOrigins;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({
      "order_by": "none"
    });
  }]).controller(id + '.Person', ['$scope', 'CardUtils', '$routeParams', 'CardQueryResource', 'CardRegistry', id + ".Utils", id + '.PageText', function ($scope, CardUtils, $routeParams, CardQueryResource, CardRegistry, Utils, PageText) {
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.personId = $routeParams.personId;
    $scope.config = $scope.card.configuration;

    // Base url for fetching interactions -- this is unqiue because we need the
    // card's filter plus the person Id we feed it
    $scope.baseUrl = "program/person/" + $scope.personId + "/interactions";

    // Define program in JSON then fetch data from the main transformer
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($routeParams.cardId, $scope).then(function success(response) {
      var data = response.results[0].result;
      $scope.fetchInProgress = false;
      $scope.program = data.program;
      $scope.hasData = true;
      CardUtils.setNavElements($scope, $scope.program.name);
      var pageText = PageText.bind({
        cardConfig: $scope.config
      }).lift("personCompletedStatusHeadline", function () {
        var path = "";
        if ($scope.program.progress === 0) {
          path = "personHasNotStartedProgram";
        }
        if ($scope.program.progress > 0) {
          path = "personCompletedPercentage";
        }
        if ($scope.program.progress === 1) {
          path = "personHasFinishedProgram";
        }
        var percentCompleted = Math.round($scope.program.progress * 100 * 10) / 10;
        return this.render("program.personDetail.".concat(path), {
          person: $scope.program.name,
          learningPath: $scope.program.learningPathName,
          percentCompleted: percentCompleted
        });
      }).lift("lastMilestoneProgressTableHeader", function () {
        return this.render('program.personDetail.lastMilestoneProgress');
      }).lift("milestoneSectionHeader", function (count) {
        var singular = "Milestone";
        return this.render('program.personDetail.milestoneSectionHeader', {
          resultCount: count,
          resultType: count === 1 ? singular : singular + 's'
        });
      });
      $scope.pageText = pageText;
      Utils.setupActivityChart(data.dailyActivity, $scope);
    });
  }]).controller(id + '.PersonMilestonesLister', ['$scope', '$q', id + ".Utils", id + '.PageText', '$routeParams', '$controller', function ($scope, $q, Utils, PageText, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a milestone";
    $scope.inputSize = "23";
    $scope.pageSize = 20;
    $scope.defaultSortBy = 'none';
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    var pageText = PageText.bind({
      cardConfig: $scope.config
    });
    $scope.sortControls = [{
      //"title": "Milestone",
      "title": pageText.render('program.personDetail.milestoneTableMilestoneColumn'),
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Started",
      "options": {
        "Ascending": "firstAccess",
        "Descending": "-firstAccess"
      }
    }, {
      "title": "Progress",
      "options": {
        "Ascending": "progress",
        "Descending": "-progress"
      }
    }, {
      "title": "Status",
      "options": {
        "Ascending": "complete",
        "Descending": "-complete"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      params.limit = params.limit || $scope.pageSize;
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.milestones.filter(function (m) {
          return m.metadata && m.metadata.type && m.metadata.type !== 'collection';
        });
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({
      "order_by": "none"
    });
  }]).controller(id + '.PersonLearningPathsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a learning path";
    $scope.inputSize = "23";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Learning Path",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Started",
      "options": {
        "Ascending": "firstAccess",
        "Descending": "-firstAccess"
      }
    }, {
      "title": "Progress",
      "options": {
        "Ascending": "progress",
        "Descending": "-progress"
      }
    }, {
      "title": "Status",
      "options": {
        "Ascending": "complete",
        "Descending": "-complete"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.learningPaths;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonAssessmentsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an assessment";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Assessment",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Complete",
      "options": {
        "Ascending": "complete",
        "Descending": "-complete"
      }
    }, {
      "title": "Successful",
      "options": {
        "Ascending": "successful",
        "Descending": "-successful"
      }
    }, {
      "title": "Last score",
      "options": {
        "Ascending": "score",
        "Descending": "-score"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.assessments;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonCompetenciesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a competency";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Competency",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Proficiency",
      "options": {
        "Ascending": "score",
        "Descending": "-score"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "matchCount",
        "Descending": "-matchCount"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.competencies;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonContributingSystemsLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a system";
    $scope.pageSize = 50;
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Contributing System",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Activities",
      "options": {
        "Ascending": "uniqueActivityCount",
        "Descending": "-uniqueActivityCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        if ($scope.config.program.dataOrigins === null || $scope.config.program.dataOrigins.length === 0) {
          return [];
        }
        return data.dataOrigins;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PersonUniqueActivitiesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an activity";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Activity",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Contributing system",
      "options": {
        "Ascending": "dataOrigin",
        "Descending": "-dataOrigin"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.uniqueActivities;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.LearningPathDetail', ['$scope', 'CardUtils', '$routeParams', 'CardQueryResource', 'CardRegistry', id + ".Utils", function ($scope, CardUtils, $routeParams, CardQueryResource, CardRegistry, Utils) {
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.config = $scope.card.configuration;

    // This controller is used for the group detail view as well.
    // The existence of this variable will cause fetchProgramData to go after a group-specific resource
    $scope.learningPathId = $routeParams.learningPathId;
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($routeParams.cardId, $scope).then(function success(response) {
      var data = response.results[0].result;
      $scope.fetchInProgress = false;
      $scope.learningPath = data.learningPath;
      $scope.milestones = data.milestones;
      $scope.milestonesTotalPercentComplete = _.reduce($scope.milestones, function (memo, milestone) {
        return memo + milestone.percentAtStep;
      }, 0);

      // Base url for fetching interactions -- this is unique because we need the
      // card's filter plus the group Id we feed it
      $scope.baseUrl = "program/learningpath/" + $scope.learningPathId + "/interactions";
      $scope.groupName = data.groupName;
      CardUtils.setNavElements($scope, data.learningPath.name);
      Utils.setupActivityChart(data.dailyActivity, $scope);
      $scope.hasData = true;
    });
  }]).controller(id + '.WorkflowDetail', ['$scope', 'CardUtils', '$routeParams', 'CardRegistry', id + ".Utils", function ($scope, CardUtils, $routeParams, CardRegistry, Utils) {
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.config = $scope.card.configuration;

    // This controller is used for the group detail view as well.
    // The existence of this veriable will cause fetchProgramData to go after a group-specific resource
    $scope.workflowId = $routeParams.workflowId;

    // for lister toggles
    $scope.listers = {};
    $scope.toggle = function (idx, name) {
      var currentValue = $scope.listers[idx + name];
      // Reset all
      $scope.listers = {};
      $scope.listers[idx + name] = !currentValue;
    };
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($routeParams.cardId, $scope).then(function success(response) {
      var data = response.results[0].result;
      $scope.fetchInProgress = false;
      $scope.workflow = data.workflow;
      CardUtils.setNavElements($scope, data.workflow.name);
      $scope.stepsTotalPercentComplete = _.reduce($scope.workflow.expectedPath.workflowStepAggregations, function (memo, step) {
        return memo + step.percentComplete;
      }, 0);
      $scope.hasData = true;
    });
  }]).controller(id + ".Assessment", ["$scope", id + ".Utils", "CardUtils", '$routeParams', 'CardRegistry', '$controller', 'Api', 'Resource', id + ".Utils", function ($scope, programUtils, CardUtils, $routeParams, CardRegistry, $controller, Api, Resource, Utils) {
    // clone card so title can be set without changing original card title
    $scope.card = _.clone(CardRegistry.get($routeParams.cardId));
    $scope.cardId = $routeParams.cardId;
    $scope.assessmentIndex = $routeParams.assessmentIndex;
    $scope.isPartial = true;

    // Setting this baseUrl for use by the interactions
    $scope.baseUrl = "program/assessment/" + $scope.assessmentIndex + "/interactions";

    // Setup the daily activity over time data
    programUtils.fetchProgramData($scope.cardId, $scope).then(function (data) {
      Utils.setupActivityChart(data.results[0].result.dailyActivity, $scope);
    });
    $scope.hasData = null;

    // Find the assessment in our program config so we can use the descriptive name
    $scope.assessment = $scope.card.configuration.program.assessments[$scope.assessmentIndex];
    $scope.card.title = $scope.assessment.name;

    //for detail page we'll always be looking at a single activity/assessment
    $scope.activityCount = 1;
    $scope.overviewUrl = Api.url("/program/assessment/" + $scope.assessmentIndex + "/overview?cardId=" + $scope.card.id);
    $scope.questionsUrl = Api.url("/program/assessment/" + $scope.assessmentIndex + "/questions?cardId=" + $scope.card.id);
    $scope.promises = {
      reportPromise: null
    };
    $controller('activity.Detail', {
      $scope: $scope
    });

    // Do all of the additions/modifications to customize the activity detail data for
    // use within the program assessments page
    $scope.$on('activity-loaded', function (event, args) {
      if ($scope.programAssessmentHandled) {
        return;
      }
      var data = args.data;
      CardUtils.setNavElements($scope, $scope.assessment.name);

      // Dont' expose csv download, at least not yet
      $scope.csvData = null;
      var completedResults = _.filter(data.LISTER.result.allAttempts.results, function (p) {
        return p.completions > 0;
      });
      var incompleteResults = _.filter(data.LISTER.result.allAttempts.results, function (p) {
        return p.completions === 0;
      });

      // Edit the leaderboard section for the Program assessments page and add an additional section
      _.each($scope.firstSections, function (section, idx) {
        if (section.leaderboard) {
          // Add an additional 'incomplete' section after leaderboard
          if (incompleteResults.length > 0) {
            var incompleteResultsSection = {
              bullet: null,
              chart: null,
              customCharts: null,
              title: {
                text: null,
                emphasized: false
              },
              subtitle: null,
              currentDuration: "Month",
              updateChartData: null,
              durations: [],
              height: 400,
              width: undefined,
              questionId: null,
              isQuestion: false,
              incompleteResults: true,
              assessment: $scope.assessment,
              templateUrl: "modules/app/activity/detail/incomplete-people.html",
              data: incompleteResults,
              sortControls: [{
                "title": "People",
                "options": {
                  "Ascending": "name",
                  "Descending": "-name"
                }
              }, {
                "title": "Interactions",
                "options": {
                  "Ascending": "statementCount",
                  "Descending": "-statementCount"
                }
              }, {
                "title": "Last interaction",
                "options": {
                  "Ascending": "lastAccess",
                  "Descending": "-lastAccess"
                }
              }, {
                "title": "Time Span",
                "options": {
                  "Ascending": "totalTimeCentiseconds",
                  "Descending": "-totalTimeCentiseconds"
                }
              }]
            };
            $scope.sortControls = Utils.filterHiddenSortControls($scope);

            // Insert this new section after leaderboard
            $scope.firstSections.splice(idx + 1, 0, incompleteResultsSection);
          }

          // Remove (if empty) or modify the leaderboard section
          if (completedResults.length === 0) {
            $scope.firstSections.splice(idx, 1);
          } else {
            section.title.text = completedResults.length + (completedResults.length === 1 ? " person has completed " : " people have completed ") + $scope.assessment.name;

            // Override the timeline callback to point to program-scoped endpoint
            section.timelineCallback = function (leaderboardEntries) {
              var timelineResource = new Resource("program/assessment/" + $scope.assessmentIndex + "/timeline", false);
              return timelineResource.get("", {
                params: {
                  cardId: $scope.cardId,
                  personIds: _.pluck(leaderboardEntries, "personId")
                }
              }).then(function (response) {
                return {
                  data: response
                };
              });
            };
            // show only completedResults in the leaderboard
            section.data.allAttempts.results = completedResults;
          }
        }
      });
      $scope.programAssessmentHandled = true;
    });
  }]).controller(id + '.AssessmentGroupLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for group";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Assessment",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "People completed",
      "options": {
        "Ascending": "completionCount",
        "Descending": "-completionCount"
      }
    }, {
      "title": "Successes",
      "options": {
        "Ascending": "successCount",
        "Descending": "-successCount"
      }
    }, {
      "title": "Average score",
      "options": {
        "Ascending": "averageScore",
        "Descending": "-averageScore"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "totalDurationSeconds",
        "Descending": "-totalDurationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.groupResults;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).directive("wsProgramListerView", ["$q", "$controller", "wsPaginate", id + ".Utils", function ($q, $controller, Paginate, Utils) {
    return {
      template: '<div ng-include="templateUrl"></div>',
      scope: {
        definition: "="
      },
      link: function link(scope) {
        // Assign things from the definition to the scope
        scope.cachedListerItems = scope.definition.data;
        scope.assessment = scope.definition.assessment;
        scope.templateUrl = scope.definition.templateUrl;
        scope.sortControls = scope.definition.sortControls;
        scope.searchPlaceholder = "Search for a Person";
        $controller('ListerBaseCtrl', {
          $scope: scope
        });
        scope.fetchData = function fetchData(params) {
          return Utils.fetchData(params, scope, function getListerData(data) {
            return data;
          });
        };
        scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
          return Utils.fetchSearchSuggestions(params, scope);
        };
      }
    };
  }]).controller(id + '.Competency', ['$scope', 'CardUtils', '$routeParams', 'CardQueryResource', 'CardRegistry', id + ".Utils", function ($scope, CardUtils, $routeParams, CardQueryResource, CardRegistry, Utils) {
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.competencyId = $routeParams.competencyId;
    $scope.config = $scope.card.configuration;

    // Base url for fetching interactions -- this is unqiue because we need the
    // card's filter plus the person Id we feed it
    $scope.baseUrl = "program/competency/" + $scope.competencyId + "/interactions";

    // Define program in JSON then fetch data from the main transformer
    //CardQueryResource.getWithProgress("/program/learningPaths", $routeParams.cardId, null, null, "programProgress").then(
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($routeParams.cardId, $scope).then(function success(response) {
      var data = response.results[0].result;
      $scope.competencyAgg = data.competencyAgg;
      $scope.proficiencyByDay = _.map(data.proficiencyByDay, function (val) {
        return [Date.parse(val[0]), val[1] * 100];
      });
      $scope.proficiencyByMonth = [];
      // Iterate over data points. Pick off first 7 chars, that's the year/month
      var prevMonth = data.proficiencyByDay[0][0].substring(0, 7);
      var total = 0;
      var totalCount = 0;
      _.each(data.proficiencyByDay, function (val) {
        var month = val[0].substring(0, 7);
        if (month !== prevMonth) {
          // Calculate monthly stats, save data point, and reset stats
          $scope.proficiencyByMonth.push([Date.parse(prevMonth + '-01'), total / totalCount]);
          total = 0;
          totalCount = 0;
          prevMonth = month;
        }
        totalCount++;
        total = total + val[1] * 100;
      });
      $scope.fetchInProgress = false;
      $scope.milestones = data.milestones;
      $scope.milestonesTotalPercentComplete = _.reduce($scope.milestones, function (memo, milestone) {
        return memo + milestone.percentComplete;
      }, 0);
      $scope.hasData = true;
      $scope.competencyName = data.competencyAgg.name;
      CardUtils.setNavElements($scope, data.competencyAgg.name);
      Utils.setupActivityChart(data.dailyActivity, $scope);
      $scope.avgProficiencyChart = {
        chart: {
          type: 'column'
        },
        title: {
          text: null
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%b %e',
            week: '%b %e',
            year: '%b'
          },
          title: {
            text: null
          }
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: null
          },
          labels: {
            format: '{value}%'
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        series: [{
          data: $scope.proficiencyByMonth
        }]
      };
      $scope.selectedInterval = "Month";
      $scope.$watch('selectedInterval', function (value) {
        if (value === 'Day') {
          $scope.avgProficiencyChart.series[0].data = $scope.proficiencyByDay;
        } else if (value === 'Month') {
          $scope.avgProficiencyChart.series[0].data = $scope.proficiencyByMonth;
        }
      });
    });
  }]).controller(id + '.CompetencyGroupLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a group";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Group",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Average proficiency",
      "options": {
        "Ascending": "averageProficiency",
        "Descending": "-averageProficiency"
      }
    }, {
      "title": "People with competency",
      "options": {
        "Ascending": "proficientCount",
        "Descending": "-proficientCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "matchCount",
        "Descending": "-matchCount"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "totalDurationSeconds",
        "Descending": "-totalDurationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.groups;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.CompetencyPersonLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a person";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Person",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Proficiency",
      "options": {
        "Ascending": "score",
        "Descending": "-score"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "matchCount",
        "Descending": "-matchCount"
      }
    }, {
      "title": "Last interaction",
      "options": {
        "Ascending": "lastAccess",
        "Descending": "-lastAccess"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.people;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.RelatedCompetenciesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a competency";
    $scope.inputSize = "22";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Competency",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Average proficiency",
      "options": {
        "Ascending": "averageProficiency",
        "Descending": "-averageProficiency"
      }
    }, {
      "title": "People with competency",
      "options": {
        "Ascending": "proficientCount",
        "Descending": "-proficientCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "matchCount",
        "Descending": "-matchCount"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "totalDurationSeconds",
        "Descending": "-totalDurationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.relatedCompetencies;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.DataOriginDetail', ['$scope', 'CardUtils', '$routeParams', 'CardQueryResource', 'CardRegistry', id + ".Utils", function ($scope, CardUtils, $routeParams, CardQueryResource, CardRegistry, Utils) {
    $scope.card = CardRegistry.get($routeParams.cardId);
    $scope.config = $scope.card.configuration;

    // This controller is used for the group detail view as well.
    // The existence of this veriable will cause fetchProgramData to go after a group-specific resource
    $scope.dataOriginIndex = $routeParams.dataOriginIndex;

    // Find the dataOrigin in our program config so we can use the descriptive name
    if ($scope.dataOriginIndex === "unknown") {
      $scope.dataOrigin = {
        "name": "Unknown"
      };
    } else {
      $scope.dataOrigin = $scope.card.configuration.program.dataOrigins[$scope.dataOriginIndex];
    }
    $scope.fetchInProgress = true;
    Utils.fetchProgramData($routeParams.cardId, $scope).then(function success(response) {
      var data = response.results[0].result;
      $scope.fetchInProgress = false;

      // Base url for fetching interactions -- this is unique because we need the
      // card's filter plus the group Id we feed it
      $scope.baseUrl = "program/dataorigin/" + $scope.dataOriginIndex + "/interactions";
      CardUtils.setNavElements($scope, $scope.dataOrigin.name);
      Utils.setupActivityChart(data.dailyActivity, $scope);
      $scope.hasData = true;
    });
  }]).controller(id + '.GroupUniqueActivitiesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a group";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Group",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Activities",
      "options": {
        "Ascending": "uniqueActivityCount",
        "Descending": "-uniqueActivityCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "totalActivites",
        "Descending": "-totalActivites"
      }
    }, {
      "title": "Time span",
      "options": {
        "Ascending": "timeSpent",
        "Descending": "-timeSpent"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.groupUniqueActivities;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.PeopleUniqueActivitiesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for a person";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Person",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Activities",
      "options": {
        "Ascending": "uniqueActivityCount",
        "Descending": "-uniqueActivityCount"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "totalActivites",
        "Descending": "-totalActivites"
      }
    }, {
      "title": "Time span",
      "options": {
        "Ascending": "timeSpent",
        "Descending": "-timeSpent"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.personUniqueActivities;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.UniqueActivitiesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an activity";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Activity",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Duration",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.uniqueActivities;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + '.UniqueActivityTypesLister', ['$scope', '$q', id + ".Utils", '$routeParams', '$controller', function ($scope, $q, Utils, $routeParams, $controller) {
    $scope.searchPlaceholder = "Search for an activity type";
    $scope.inputSize = "25";
    $controller('ListerBaseCtrl', {
      $scope: $scope
    });
    $scope.sortControls = [{
      "title": "Activity type",
      "options": {
        "Ascending": "name",
        "Descending": "-name"
      }
    }, {
      "title": "Interactions",
      "options": {
        "Ascending": "statementCount",
        "Descending": "-statementCount"
      }
    }, {
      "title": "Time span",
      "options": {
        "Ascending": "durationSeconds",
        "Descending": "-durationSeconds"
      }
    }];
    $scope.sortControls = Utils.filterHiddenSortControls($scope);
    $scope.fetchData = function fetchData(params) {
      return Utils.fetchData(params, $scope, function getListerData(data) {
        return data.uniqueActivityTypes;
      });
    };
    $scope.fetchSearchSuggestions = function fetchSearchSuggestions(params) {
      return Utils.fetchSearchSuggestions(params, $scope);
    };
    $scope.dataFetched = $scope.fetchData({});
  }]).controller(id + ".CardConfiguration", ["$scope", 'Api', '$http', id + ".Utils", '$q', 'Utils', 'Activities', function ($scope, Api, $http, ProgramUtils, $q, Utils, Activities) {
    //---------------
    // NOTE: We're putting our state in this workingConfig object which is in the explorer scope
    // so that we can share state between the main instance of this config, and the secondary
    // instances that are run when we open dialogs (such as creating new steps, etc.)
    //---------------
    $scope.workingConfig.type = id;
    ProgramUtils.clearCachedPromises();
    if (!$scope.customConfig.dialogView) {
      $scope.customConfig.dialogView = [];
    }
    if (!$scope.workingConfig.program) {
      $scope.workingConfig.program = {
        "name": "explorer-configured",
        "primaryPathId": "main",
        "learningPaths": [],
        "competencies": [],
        "assessments": []
      };
      $scope.workingConfig.hideOptions = {
        "program": {
          "duration": false,
          "groups": false,
          "people": false,
          "activities": false,
          "milestones": false,
          "interactions": false,
          "contributingSystems": false,
          "peopleInProgram": false
        },
        "groups": {
          "group": false,
          "averageProgress": false,
          "peopleNotStarted": false,
          "peopleInProgress": false,
          "peopleCompleted": false,
          "averageTimeToComplete": false
        },
        "people": {
          "person": false,
          "progress": false,
          "status": false,
          "lastMilestoneProgress": false,
          "duration": false,
          "timeSpan": false,
          "completionDate": false
        }
      };
    }
    if ($scope.workingConfig.program.name === "explorer-configured") {
      $scope.showExplorerConfig = true;
    }

    // Controlling this disabled flag explicitly because of the oddity of having the edit/delete
    // buttons within the draggable list item -- when hovering/clicking these actions we don't want to
    // be able to drag the items -- this was preventing the edit/delete actions from triggering sometimes.
    $scope.sortableOptions = {
      disabled: false
    };
    function createLearningPath() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        id = _ref2.id,
        _ref2$name = _ref2.name,
        name = _ref2$name === void 0 ? "" : _ref2$name,
        _ref2$ordered = _ref2.ordered,
        ordered = _ref2$ordered === void 0 ? true : _ref2$ordered;
      $scope.workingConfig.program.learningPaths.push({
        id: id,
        name: name,
        type: "learningPath",
        steps: [],
        ordered: ordered
      });
    }
    function initLearningPaths() {
      if ($scope.workingConfig.program.learningPaths.length === 0) {
        var ordered = isStepCompletionOrdered();
        createLearningPath({
          name: "main",
          ordered: ordered
        });
      }
    }
    function cleanStepFilter(step) {
      var clean = function clean(step) {
        if (_.isEmpty(step.filter.activityIds.ids[0])) {
          delete step.filter.activityIds;
        }
        if (_.isEmpty(step.filter.verbIds.ids[0])) {
          delete step.filter.verbIds;
        }
      };
      if (step.type === "match") {
        clean(step);
      }
      if (step.type === "collection") {
        step.steps.forEach(clean);
      }
    }
    function addProgramStep(step) {
      cleanStepFilter(step);
      $scope.workingConfig.program.learningPaths[0].steps.push(step);
    }
    function getLearningPaths() {
      return Utils.getIn($scope, 'workingConfig.program.learningPaths');
    }
    function isLearningPathsDefined() {
      return Array.isArray(getLearningPaths());
    }

    // step completion
    function isStepCompletionSet() {
      var programSet = Utils.has($scope, 'workingConfig.program.ordered');
      var learningPathSet = Utils.has($scope, 'workingConfig.program.learningPaths[0].ordered');
      return programSet || learningPathSet;
    }
    function isStepCompletionOrdered() {
      var programOrdered = Utils.check($scope, 'workingConfig.program.ordered');
      var learningPathOrdered = Utils.check($scope, 'workingConfig.program.learningPaths[0].ordered');
      return programOrdered || learningPathOrdered;
    }
    $scope.isStepCompletionOrdered = isStepCompletionOrdered;
    function setStepCompletionOrdered(ordered) {
      var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref3$override = _ref3.override,
        override = _ref3$override === void 0 ? true : _ref3$override,
        _ref3$init = _ref3.init,
        init = _ref3$init === void 0 ? true : _ref3$init;
      var stepCompletionSet = isStepCompletionSet();
      if (init && !stepCompletionSet || override && stepCompletionSet) {
        Utils.setIn($scope, 'workingConfig.program.ordered', ordered);
        if (isLearningPathsDefined() && getLearningPaths().length > 0) {
          Utils.setIn(Utils.getIn($scope, 'workingConfig.program.learningPaths[0]'), 'ordered', ordered);
        }
      }
    }
    $scope.setStepCompletionOrdered = setStepCompletionOrdered;
    var defaultCustomConfig = {
      selectedActivity: null,
      selectedVerb: null
    };
    var initStepEditor = function initStepEditor(editor) {
      var customConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCustomConfig;
      var _ref4 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
        _ref4$replaceCustomCo = _ref4.replaceCustomConfig,
        replaceCustomConfig = _ref4$replaceCustomCo === void 0 ? false : _ref4$replaceCustomCo;
      if (replaceCustomConfig) {
        $scope.customConfig = customConfig;
      } else {
        Object.assign($scope.customConfig, customConfig || {});
      }
      if (!Array.isArray($scope.customConfig.dialogView)) {
        $scope.customConfig.dialogView = [];
      }
      $scope.customConfig.dialogView.push(editor);
    };
    function getSelectedActivity(step) {
      if (step && step.filter && step.filter.activityIds) {
        var _id = step.filter.activityIds.ids[0];
        return $scope.getActivityName(_id);
      }
      return Promise.resolve(null);
    }
    function getSelectedVerb(step) {
      if (step && step.filter && step.filter.verbIds) {
        var _id2 = step.filter.verbIds.ids[0];
        return $scope.getVerbName(_id2);
      }
      return Promise.resolve(null);
    }
    function getActivityEditorData(step) {
      return Promise.all([getSelectedActivity(step), getSelectedVerb(step)]).then(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
          a = _ref6[0],
          v = _ref6[1];
        $scope.customConfig.selectedActivity = a;
        $scope.customConfig.selectedVerb = v;
      }).then(function () {
        return step;
      });
    }

    // Simple Step Editor
    $scope.addStep = function addStep() {
      initStepEditor("stepEditor");
      delete $scope.validationErrors;
      $scope.customConfig.stepToEdit = {
        "name": "",
        "filter": {
          "activityIds": {
            "ids": [""]
          },
          "verbIds": {
            "ids": [""]
          }
        },
        "type": "match",
        "successfulResultRequired": false,
        "optionalStep": false
      };
      $scope.customConfig.isNewStep = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('stepEditor', true);
    };
    function openEditor(step) {
      if (typeof step === 'string') {
        return function (s) {
          $scope.openDialog(step, true);
          return s;
        };
      }
      var editor = step.type === "collection" ? "advancedStepEditor" : "stepEditor";
      $scope.openDialog(editor, true);
      return step;
    }
    function setupStepUpdate(step) {
      var editor = step.type === "collection" ? "advancedStepEditor" : "stepEditor";
      var optionalStep = !!step.optionalStep;
      if (editor === 'advancedStepEditor') {
        $scope.customConfig.advancedStepToEdit = Object.assign({}, step, {
          optionalStep: optionalStep
        });
        $scope.customConfig.updateAdvancedStep = function () {
          return Object.assign(step, $scope.customConfig.advancedStepToEdit);
        };
        $scope.customConfig.isNewAdvancedStep = false;
      } else {
        $scope.customConfig.stepToEdit = Object.assign({}, step, {
          optionalStep: optionalStep
        });
        $scope.customConfig.updateSimpleStep = function () {
          return Object.assign(step, $scope.customConfig.stepToEdit);
        };
        $scope.customConfig.isNewStep = false;
      }
      return step;
    }
    $scope.editStep = function editStep(step) {
      initStepEditor(step.type === "collection" ? "advancedStepEditor" : "stepEditor");
      getActivityEditorData(step).then(setupStepUpdate).then(openEditor);
    };
    $scope.clearSimpleStepEditor = function clearSimpleStepEditor() {
      $scope.customConfig.stepToEdit = null;
      $scope.customConfig.updateSimpleStep = null;
      $scope.customConfig.isNewStep = false;
    };
    $scope.saveStep = function saveStep() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.stepToEdit.name)) {
        $scope.validationErrors.push("Please enter Simple Step Name");
      }
      if (_.isEmpty(Utils._try(function () {
        return $scope.customConfig.stepToEdit.filter.activityIds.ids[0];
      }, [])) && _.isEmpty(Utils._try(function () {
        return $scope.customConfig.stepToEdit.filter.verbIds.ids[0];
      }, []))) {
        $scope.validationErrors.push("Please select an existing activity or verb");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }

      // Let the server-side code reconstruct the id so it's in line with any name changes
      delete $scope.customConfig.stepToEdit.id;

      // If it's the first step, go ahead and create the learning path
      initLearningPaths();
      if ($scope.customConfig.isNewStep) {
        var stepToEdit = angular.copy($scope.customConfig.stepToEdit);
        addProgramStep(stepToEdit);
        $scope.customConfig.isNewStep = false;
      } else {
        $scope.customConfig.updateSimpleStep();
      }
      $scope.clearSimpleStepEditor();
      $scope.back();
    };
    $scope.cancelEditSimpleStep = function cancelEditSimpleStep() {
      $scope.clearSimpleStepEditor();
      $scope.back();
    };
    $scope.deleteStep = function deleteStep(step, parentStep) {
      if (step.type === "competency") {
        $scope.workingConfig.program.competencies = _.filter($scope.workingConfig.program.competencies, function (s) {
          return s.name !== step.name;
        });
      } else if (parentStep) {
        parentStep.steps = _.filter(parentStep.steps, function (s) {
          return s.name !== step.name;
        });
        if (parentStep.type === "competency") {
          parentStep.stepWeights = {};
          _.each(parentStep.steps, function editWeights(step) {
            parentStep.stepWeights[step.name] = 1 / parentStep.steps.length;
          });
        }
      } else {
        $scope.workingConfig.program.learningPaths[0].steps = _.filter($scope.workingConfig.program.learningPaths[0].steps, function (s) {
          return s.name !== step.name;
        });
        if ($scope.workingConfig.program.learningPaths[0].steps.length === 0) {
          $scope.workingConfig.program.learningPaths = [];
        }
      }
    };
    function makeAdvancedStep() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref7$name = _ref7.name,
        name = _ref7$name === void 0 ? '' : _ref7$name,
        _ref7$activities = _ref7.activities,
        activities = _ref7$activities === void 0 ? [] : _ref7$activities,
        _ref7$verbId = _ref7.verbId,
        verbId = _ref7$verbId === void 0 ? "" : _ref7$verbId,
        _ref7$successfulResul = _ref7.successfulResultRequired,
        successfulResultRequired = _ref7$successfulResul === void 0 ? false : _ref7$successfulResul,
        _ref7$optionalStep = _ref7.optionalStep,
        optionalStep = _ref7$optionalStep === void 0 ? false : _ref7$optionalStep;
      return {
        name: name,
        steps: activities.map(function (_ref8) {
          var name = _ref8.name,
            activityId = _ref8.activityId;
          return makeSimpleStep({
            name: name,
            activityId: activityId,
            verbId: verbId,
            successfulResultRequired: successfulResultRequired,
            optionalStep: optionalStep
          });
        }),
        type: "collection"
      };
    }
    function makeSimpleStep() {
      var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref9$name = _ref9.name,
        name = _ref9$name === void 0 ? "" : _ref9$name,
        _ref9$activityId = _ref9.activityId,
        activityId = _ref9$activityId === void 0 ? "" : _ref9$activityId,
        _ref9$verbId = _ref9.verbId,
        verbId = _ref9$verbId === void 0 ? "" : _ref9$verbId,
        _ref9$successfulResul = _ref9.successfulResultRequired,
        successfulResultRequired = _ref9$successfulResul === void 0 ? false : _ref9$successfulResul,
        _ref9$optionalStep = _ref9.optionalStep,
        optionalStep = _ref9$optionalStep === void 0 ? false : _ref9$optionalStep;
      return {
        name: name,
        filter: {
          activityIds: {
            ids: [activityId]
          },
          verbIds: {
            ids: [verbId]
          }
        },
        successfulResultRequired: successfulResultRequired,
        optionalStep: optionalStep,
        type: "match"
      };
    }

    // Advanced Step Editor
    $scope.addAdvancedStep = function addAdvancedStep() {
      $scope.customConfig.dialogView.push("advancedStepEditor");
      delete $scope.validationErrors;
      $scope.customConfig.advancedStepToEdit = makeAdvancedStep();
      $scope.customConfig.isNewAdvancedStep = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('advancedStepEditor', true);
    };
    $scope.clearAdvancedStepEditor = function clearAdvancedStepEditor() {
      $scope.customConfig.isNewAdvancedStep = false;
      $scope.customConfig.advancedStepToEdit = null;
      $scope.customConfig.updateAdvancedStep = null;
    };
    $scope.saveAdvancedStep = function saveAdvancedStep() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.advancedStepToEdit.name)) {
        $scope.validationErrors.push("Please enter Advanced Step Name");
      }
      if ($scope.customConfig.advancedStepToEdit.steps.length === 0) {
        $scope.validationErrors.push("Please add at least one Advanced Activity Step");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }

      // Delete ids so we can reconstruct them from edited step names
      delete $scope.customConfig.advancedStepToEdit.id;
      _.each($scope.customConfig.advancedStepToEdit.steps, function (step) {
        delete step.id;
      });

      // If it's the first step, go ahead and create the learning path
      initLearningPaths();
      if ($scope.customConfig.isNewAdvancedStep) {
        addProgramStep($scope.customConfig.advancedStepToEdit);
      } else {
        $scope.customConfig.updateAdvancedStep();
      }
      $scope.clearAdvancedStepEditor();
      $scope.back();
    };
    $scope.cancelEditAdvancedStep = function cancelEditAdvancedStep() {
      $scope.clearAdvancedStepEditor();
      $scope.back();
    };
    $scope.addAdvancedActivity = function addAdvancedActivity() {
      initStepEditor("advancedActivityEditor");
      delete $scope.validationErrors;
      $scope.customConfig.activityToEdit = makeSimpleStep();
      $scope.customConfig.isNewActivity = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('advancedActivityEditor', true);
    };
    function setupActivityUpdate(step) {
      $scope.customConfig.activityToEdit = Object.assign({}, step);
      $scope.customConfig.updateActivity = function () {
        return Object.assign(step, $scope.customConfig.activityToEdit);
      };
      return step;
    }
    $scope.editAdvancedActivity = function editAdvancedActivity(step) {
      initStepEditor("advancedActivityEditor", {
        selectedActivity: null,
        selectedVerb: null,
        isNewStep: false
      });
      getActivityEditorData(step).then(setupActivityUpdate).then(openEditor("advancedActivityEditor"));
    };
    $scope.clearAdvancedActivityEditor = function clearAdvancedActivityEditor() {
      $scope.customConfig.isNewActivity = false;
      $scope.customConfig.activityToEdit = null;
      $scope.customConfig.updateActivity = null;
    };
    $scope.saveAdvancedActivity = function saveAdvancedActivity() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.activityToEdit.name)) {
        $scope.validationErrors.push("Please enter Simple Step Name");
      }
      if (_.isEmpty($scope.customConfig.activityToEdit.filter.activityIds.ids[0])) {
        $scope.validationErrors.push("Please select an existing activity");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }
      if ($scope.customConfig.isNewActivity) {
        $scope.customConfig.advancedStepToEdit.steps.push($scope.customConfig.activityToEdit);
      } else {
        $scope.customConfig.updateActivity();
      }
      $scope.clearAdvancedActivityEditor();
      $scope.back();
    };
    $scope.cancelEditAdvancedActivity = function cancelEditAdvancedActivity() {
      $scope.clearAdvancedActivityEditor();
      $scope.back();
    };

    // Context Step Editor
    function isAddSimpleContextSteps() {
      return !!$scope.customConfig.addSimpleContextSteps;
    }
    $scope.isAddSimpleContextSteps = isAddSimpleContextSteps;
    function setAddSimpleContextSteps(b) {
      $scope.customConfig.addSimpleContextSteps = b;
    }
    $scope.setAddSimpleContextSteps = setAddSimpleContextSteps;
    function isIncludeContextActivity() {
      return !!$scope.customConfig.includeContextActivity;
    }
    $scope.isIncludeContextActivity = isIncludeContextActivity;
    function setIncludeContextActivity(b) {
      $scope.customConfig.includeContextActivity = b;
    }
    $scope.setIncludeContextActivity = setIncludeContextActivity;
    $scope.addContextStep = function addContextStep() {
      initStepEditor("contextStepEditor");
      setAddSimpleContextSteps(false);
      setIncludeContextActivity(false);
      delete $scope.validationErrors;
      $scope.customConfig.contextStepToEdit = {
        "name": "",
        "contextActivityId": "",
        "verbId": "",
        "successfulResultRequired": false,
        "optionalStep": false,
        "type": "context"
      };
      $scope.customConfig.isNewContextStep = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('contextStepEditor', true);
    };
    $scope.saveContextStep = function saveContextStep() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.contextStepToEdit.name) && !$scope.customConfig.addSimpleContextSteps) {
        $scope.validationErrors.push("Please enter Context Step Name");
      }
      if (_.isEmpty($scope.customConfig.contextStepToEdit.contextActivityId)) {
        $scope.validationErrors.push("Please add a Context Activity Id");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }
      Activities.multiGetByContextId([$scope.customConfig.contextStepToEdit.contextActivityId], {
        includeContextActivity: $scope.customConfig.includeContextActivity
      }).then(function (_ref0) {
        var results = _ref0.results;
        initLearningPaths();
        if ($scope.customConfig.addSimpleContextSteps) {
          results.forEach(function (step) {
            return addProgramStep(makeSimpleStep({
              name: step.name,
              activityId: step.activityId,
              verbId: $scope.customConfig.contextStepToEdit.verbId,
              successfulResultRequired: $scope.customConfig.contextStepToEdit.successfulResultRequired,
              optionalStep: $scope.customConfig.contextStepToEdit.optionalStep
            }));
          });
        } else {
          addProgramStep(makeAdvancedStep({
            name: $scope.customConfig.contextStepToEdit.name,
            activities: results,
            verbId: $scope.customConfig.contextStepToEdit.verbId,
            successfulResultRequired: $scope.customConfig.contextStepToEdit.successfulResultRequired,
            optionalStep: $scope.customConfig.contextStepToEdit.optionalStep
          }));
        }
        $scope.customConfig.isNewContextStep = false;
        $scope.back();
      });
    };

    // Competency Editor
    $scope.addCompetency = function addCompetency() {
      $scope.customConfig.dialogView.push("competencyEditor");
      delete $scope.validationErrors;
      $scope.customConfig.competencyToEdit = {
        "name": "",
        "steps": [],
        "stepWeights": {},
        "type": "competency"
      };
      $scope.customConfig.isNewCompetency = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('competencyEditor', true);
    };
    $scope.editCompetency = function editCompetency(step) {
      $scope.customConfig.dialogView.push("competencyEditor");
      $scope.customConfig.competencyToEdit = step;
      $scope.customConfig.isNewCompetency = false;
      if (step && step.filter && step.filter.activityIds && step.filter.activityIds.ids.length > 0) {
        $scope.currentActivityName = $scope.getActivityName(step.filter.activityIds.ids[0]);
      } else {
        $scope.currentActivityName = "no Name";
      }
      $scope.openDialog("competencyEditor", true);
    };
    $scope.saveCompetency = function saveCompetency() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.competencyToEdit.name)) {
        $scope.validationErrors.push("Please enter Competency Name");
      }
      if ($scope.customConfig.competencyToEdit.steps.length === 0) {
        $scope.validationErrors.push("Please add at least one Activity");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }

      // If it's the first step, go ahead and create the learning path
      if ($scope.customConfig.isNewCompetency) {
        $scope.workingConfig.program.competencies.push($scope.customConfig.competencyToEdit);
      }
      $scope.customConfig.dialogView.pop();
      if ($scope.customConfig.dialogView.length === 0) {
        //scope.dialog.show is in explorer.js
        $scope.dialog.show = false;
      }
      $scope.customConfig.isNewCompetency = false;
    };

    // Competency Activity ("skill") Editor
    $scope.addCompetencyActivity = function addCompetencyActivity() {
      $scope.customConfig.dialogView.push("competencyActivityEditor");
      $scope.customConfig.selectedActivity = null;
      delete $scope.validationErrors;
      $scope.customConfig.activityToEdit = {
        "name": "",
        "filter": {
          "activityIds": {
            "ids": [""]
          }
        },
        "type": "match",
        "successfulResultRequired": false,
        "optionalStep": true
      };
      $scope.customConfig.isNewActivity = true;

      // openDialog is defined by explorer.js
      $scope.openDialog('competencyActivityEditor', true);
    };
    $scope.editCompetencyActivity = function editCompetencyActivity(step) {
      $scope.customConfig.dialogView.push("competencyActivityEditor");
      $scope.customConfig.isNewActivity = false;
      if (step && step.filter && step.filter.activityIds && step.filter.activityIds.ids.length > 0) {
        $scope.getActivityName(step.filter.activityIds.ids[0]).then(function (name) {
          $scope.customConfig.selectedActivity = {
            'name': name,
            'activityId': step.filter.activityIds.ids[0]
          };
          $scope.customConfig.activityToEdit = step;
          $scope.openDialog("competencyActivityEditor", true);
        });
      } else {
        $scope.currentActivityName = "no Name";
        $scope.customConfig.activityToEdit = step;
        $scope.openDialog("competencyActivityEditor", true);
      }
    };
    $scope.saveCompetencyActivity = function saveCompetencyActivity() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.activityToEdit.name)) {
        $scope.validationErrors.push("Please enter Activity Name");
      }
      if (_.isEmpty($scope.customConfig.activityToEdit.filter.activityIds.ids[0])) {
        $scope.validationErrors.push("Please select an existing activity");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }
      if ($scope.customConfig.isNewActivity) {
        $scope.customConfig.competencyToEdit.steps.push($scope.customConfig.activityToEdit);
        $scope.customConfig.isNewActivity = false;
      }
      // Automatically calculate an equal weighting
      $scope.customConfig.competencyToEdit.stepWeights = {};
      _.each($scope.customConfig.competencyToEdit.steps, function editWeights(step) {
        $scope.customConfig.competencyToEdit.stepWeights[step.name] = 1 / $scope.customConfig.competencyToEdit.steps.length;
      });
      $scope.back();
    };

    // Assessment Editor
    $scope.addAssessment = function addAssessment() {
      $scope.customConfig.dialogView.push("assessmentEditor");
      $scope.customConfig.selectedActivity = null;
      delete $scope.validationErrors;
      $scope.customConfig.assessmentToEdit = {
        "name": "",
        "activityId": ""
      };
      $scope.customConfig.isNewAssessment = true;
      $scope.openDialog('assessmentEditor', true);
    };
    $scope.editAssessment = function editAssessment(assessment) {
      $scope.customConfig.dialogView.push("assessmentEditor");
      $scope.customConfig.assessmentToEdit = assessment;
      $scope.customConfig.isNewAssessment = false;
      if (assessment && assessment.activityId) {
        $scope.getActivityName(assessment.activityId).then(function (name) {
          $scope.customConfig.selectedActivity = {
            'name': name,
            'activityId': assessment.activityId
          };
          $scope.openDialog('assessmentEditor', true);
        });
      } else {
        $scope.openDialog('assessmentEditor', true);
      }
    };
    $scope.deleteAssessment = function deleteAssessment(index) {
      if (typeof index === 'undefined') {
        return;
      }
      $scope.workingConfig.program.assessments.splice(index, 1);
    };
    $scope.saveAssessment = function saveNewAssessment() {
      // Validate
      $scope.validationErrors = [];
      if (_.isEmpty($scope.customConfig.assessmentToEdit.name)) {
        $scope.validationErrors.push("Please enter Assessment Name");
      }
      if (_.isEmpty($scope.customConfig.assessmentToEdit.activityId)) {
        $scope.validationErrors.push("Please select an existing activity");
      }
      if ($scope.validationErrors.length > 0) {
        return false;
      }
      if ($scope.customConfig.isNewAssessment) {
        if (!$scope.workingConfig.program.assessments) {
          $scope.workingConfig.program.assessments = [];
        }
        $scope.workingConfig.program.assessments.push($scope.customConfig.assessmentToEdit);
      }
      $scope.customConfig.dialogView.pop();
      if ($scope.customConfig.dialogView.length === 0) {
        //scope.dialog.show is in explorer.js
        $scope.dialog.show = false;
      }
      $scope.customConfig.isNewAssessment = false;
    };
    $scope.$watch("workingConfig.program", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
    $scope.back = function back() {
      $scope.customConfig.dialogView.pop();
      if ($scope.customConfig.dialogView.length === 0) {
        //scope.dialog.show is in explorer.js
        $scope.dialog.show = false;
      } else {
        $scope.openDialog($scope.customConfig.dialogView[$scope.customConfig.dialogView.length - 1], true);
      }
    };
    $scope.getActivityName = function getActivityName(activityId) {
      var searchParams = {
        activityIds: [activityId],
        _limit: 1
      };
      return $http.get(Api.url('/acc/activities/multi/by-activity-id'), {
        params: searchParams
      }).then(function activitySearchSuccess(response) {
        if (response.data !== null && response.data.results && response.data.results.length > 0) {
          $scope.errorMsg = null;
          var activity = response.data.results[0];
          if (activity.name) {
            return {
              activityId: activity.activityId,
              name: activity.name || '--'
            };
          } else {
            return {
              activityId: activity.activityId,
              name: activity.activityId
            };
          }
        }
        return {};
      });
    };
    $scope.getVerbName = function getVerbName(verbId) {
      /*jshint camelcase: false */
      var searchParams = {
        searchTerm: verbId,
        order_by: "verbId",
        _limit: 1
      };
      /*jshint camelcase: true */

      return $http.get(Api.url('/acc/verbs/search'), {
        params: searchParams
      }).then(function verbSearchSuccess(response) {
        if (response.data.results.length > 0) {
          return response.data.results[0];
        }
        return {};
      });
    };
    $scope.programHelpText = {
      helpTitle: 'Program',
      detailText: 'Define one or more steps that make up a program. Each step can either be a simple step (a simple matching activity) or an advanced step composed of multiple matching activities.'
    };
    $scope.competenciesHelpText = {
      helpTitle: 'Competencies',
      detailText: 'Define one or more skills that make up a competency. Each skill correlates to an activity you specify. If these activities report a score result, that score will be used to calculate the competency on a 0.0 - 1.0 scale.'
    };
    $scope.assessmentsHelpText = {
      helpTitle: 'Assessments',
      detailText: 'Configure one more more assessments by selecting the primary activity ID of the assessment you would like to report on. If question data is reported which specifies this activity as the parent activity id, that data will be included as well.'
    };
    $scope.successRequiredHelpText = {
      helpTitle: 'Success Required',
      detailText: 'Success required means that in order for a learner to succeed at this step they must have a statement that matches the filter, and includes the result.success property set to true.'
    };
  }]).directive('wsHumanize', function () {
    var defaultHumanizedTimeString = '--';
    var timeConversions = Object.freeze([{
      bottom: 1,
      units: 'second',
      singularArticle: 'a'
    }, {
      bottom: 60,
      units: 'minute',
      singularArticle: 'a'
    }, {
      bottom: 60 * 60,
      units: 'hour',
      singularArticle: 'an'
    }, {
      bottom: 60 * 60 * 24,
      units: 'day',
      singularArticle: 'a'
    }]);
    var timeConversionMatcher = function timeConversionMatcher(seconds) {
      return function matchTimeConversion(_ref1, i, conversions) {
        var bottom = _ref1.bottom;
        return seconds >= bottom && (i + 1 >= conversions.length || seconds < conversions[i + 1].bottom);
      };
    };
    var isValidTime = function isValidTime(seconds) {
      return seconds !== null && seconds !== undefined && Number.isFinite(seconds) && seconds >= 0;
    };
    var humanizeTime = function humanizeTime(seconds) {
      if (!isValidTime(seconds)) {
        return defaultHumanizedTimeString;
      } else if (seconds === 0) {
        return "0 seconds";
      } else {
        var matchConversion = timeConversionMatcher(seconds);
        var conversion = timeConversions.find(matchConversion);
        var convertedTime = Math.floor(seconds / conversion.bottom);
        return convertedTime + " " + conversion.units + (convertedTime === 1 ? "" : "s");
      }
    };
    return {
      // restrict to an element (A = attribute, C = class, M = comment)
      // or any combination like 'EACM' or 'EC'
      restrict: 'E',
      scope: {
        seconds: '='
      },
      template: "<span style='cursor'>{{ display }}</span>",
      controller: function controller($scope) {
        $scope.display = humanizeTime($scope.seconds);
      },
      replace: true
    };
  });
})();
